import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mb-10 mb-xxl-8 d-flex flex-column" }
const _hoisted_2 = { class: "w-15" }
const _hoisted_3 = { class: "ps-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draw, (value, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "d-flex flex-row p-3"
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.formatUCwords(index)), 1),
        _createElementVNode("div", null, [
          _createTextVNode(" : "),
          _createElementVNode("span", _hoisted_3, _toDisplayString(value), 1)
        ])
      ]))
    }), 128))
  ]))
}